import { ActionCreator, Action } from 'redux';

export const setLandingPageData: ActionCreator<Action> = (data) => ({
    type: 'SET_LANDING_PAGE',
    data,
});